































import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';
import { mapGetters } from 'vuex';
// This component is used as a wrapper
// to handle language based routing.
// Sentry
import * as Sentry from '@sentry/vue';

export default mixins(auth).extend({
  name: 'LayoutsRoot',
  components: {
    LayoutAppBar: () => import('./AppBar.vue'),
    LayoutDrawer: () => import('./Drawer.vue'),
    LayoutRightDrawer: () => import('./RightDrawer.vue'),
    LayoutView: () => import('./View.vue')
  },

  data() {
    return {
      appLoading: false
    };
  },

  computed: {
    ...mapGetters({
      textLogo: 'app/lightCompanyImage'
    }),
    logo(): any {
      return this.textLogo;
    }
  },

  methods: {
    signOut() {
      this.authProvider.logout().finally(() => {
        // The accounts-lib logout only clears access__token and user. Explicitly
        // remove refresh__token so a token stored by a previous Microsoft SSO
        // session cannot be picked up by the refresh interceptor in the next session.
        localStorage.removeItem('refresh__token');
        //this refreshes the page to clear the vuex state
        window.location.href = '/auth/sign-in';
      });
    }
  },

  async created() {
    try {
      // reloading when logged in
      if (!this.authProvider.getCurrentUser.id) {
        this.appLoading = true;

        await this.authProvider.fetchMe();
      }

      // Set user information to be sent to Sentry
      if (process.env.VUE_APP_ENABLE_LOGGING === 'true') {
        Sentry.setUser({
          email: this.authProvider.getCurrentUser.email
        });
      }
    } catch (e) {
      // if error is thrown then we cannot see user or save user to sentry then just sign out
      this.signOut();
    } finally {
      this.appLoading = false;
    }
  }
});
